import { render } from "./chat_lobby.vue?vue&type=template&id=b30e7b8e"
import script from "./chat_lobby.vue?vue&type=script&lang=js"
export * from "./chat_lobby.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\discussion-guru\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__